import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { MatSnackBarConfig, MAT_SNACK_BAR_DEFAULT_OPTIONS } from '@angular/material/snack-bar';
import { CardErrorComponent } from './card-error/card-error.component';
import { DialogComponent } from './dialog/dialog.component';
import { FormErrorsComponent } from './form-errors/form-errors.component';
import { ImportJsonformsModule } from './import-jsonforms/import-jsonforms.module';
import { InputArrayGroupComponent } from './input-array-group/input-array-group.component';
import { InputArrayComponent } from './input-array/input-array.component';
import { LoadingComponent } from './loading/loading.component';
import { LocationSearchComponent } from './location-search/location-search.component';
import { LogoComponent } from './logo/logo.component';
import { MapModule } from './map/map.module';
import { ContextMenuComponent } from './menus/context-menu/context-menu.component';
import { MainMenuComponent } from './menus/main-menu/main-menu.component';
import { MenuContainerComponent } from './menus/menu-container/menu-container.component';
import { MenuPopupComponent } from './menus/menu-popup/menu-popup.component';
import { PageNotFoundComponent } from './page-not-found/page-not-found.component';
import { SuggestionComponent } from './suggestion/suggestion.component';
import { UserMenuComponent } from './user-menu/user-menu.component';
import { WindowComponent } from './window/window.component';
import { ComponentsMaterialModule } from './_material/components-material.module';
import { MapSelectStyleComponent } from './map-select-style/map-select-style.component';
import { FlyToComponent } from './fly-to/fly-to.component';
import { HelpWindowComponent } from './help/help-window/help-window.component';
import { HelpComponent } from './help/help-icon/help.component';

const SNACK_BAR_OPTIONS: MatSnackBarConfig = {
  horizontalPosition: 'end'
};

@NgModule({
  declarations: [
    MainMenuComponent,
    MenuContainerComponent,
    ContextMenuComponent,
    LoadingComponent,
    WindowComponent,
    LocationSearchComponent,
    MenuPopupComponent,
    CardErrorComponent,
    UserMenuComponent,
    PageNotFoundComponent,
    DialogComponent,
    SuggestionComponent,
    InputArrayComponent,
    LogoComponent,
    InputArrayGroupComponent,
    FormErrorsComponent,
    MapSelectStyleComponent,
    FlyToComponent,
    HelpComponent,
    HelpWindowComponent
  ],
  imports: [
    CommonModule,
    ComponentsMaterialModule,
    MapModule,
    ImportJsonformsModule,
  ],
  exports: [
    ComponentsMaterialModule,
    MapModule,
    MainMenuComponent,
    MenuContainerComponent,
    ContextMenuComponent,
    LoadingComponent,
    WindowComponent,
    LocationSearchComponent,
    CardErrorComponent,
    ImportJsonformsModule,
    UserMenuComponent,
    SuggestionComponent,
    InputArrayComponent,
    LogoComponent,
    InputArrayGroupComponent,
    FormErrorsComponent,
    MapSelectStyleComponent,
    FlyToComponent,
    HelpComponent
  ],
  providers: [
    { provide: MAT_SNACK_BAR_DEFAULT_OPTIONS, useValue: SNACK_BAR_OPTIONS }
  ]
})
export class ComponentsModule { }
